export const USER_AGREED_TO_COOKIES = 'USER_AGREED_TO_COOKIES';
export const USE_GOCATSS = 'USE_GOCATSS';

export function userAgreedToCookies(userDidAgreeToCookies) {
    return {
        type: USER_AGREED_TO_COOKIES,
        payload: {
            userAgreedToCookies: userDidAgreeToCookies,
            clientsideCookieDetectionSet: true
        }
    };
}

export function useGocatss(gocatssIsActive, gocatssDebuggerIsActive) {
    return {
        type: USE_GOCATSS,
        payload: {
            gocatssIsActive: gocatssIsActive,
            gocatssDebuggerIsActive: gocatssDebuggerIsActive
        }
    };
}
